export function Modal() {
  const body = document.querySelector("body")
  const modalScope = document.querySelectorAll(".modal-scope")
  const header = document.querySelector(".site-header")

  modalScope.forEach((element) => {
    const modal = element.querySelector(".modal-container")

    const btn = element.querySelector(".btn-modal")

    const span = element.getElementsByClassName("btn-close")[0]

    function closeModal() {
      modal.style.display = "none"
      body.style.overflowY = "scroll"
      body.style.visibility = "visible"
      header.style.display = "initial"
    }

    document.addEventListener("keyup", (e) => {
      if (modal.style.display === "block" && e.key === "Escape") {
        closeModal()
      }
    })

    if (btn) {
      btn.onclick = function block() {
        modal.style.display = "block"
        body.style.overflowY = "hidden"
        body.style.visibility = "hidden"
        header.style.display = "none"
      }
    }

    if (span) {
      span.onclick = function close() {
        closeModal()
      }
    }

    window.onclick = function hide(event) {
      if (event.target === modal) {
        closeModal()
      }
    }
  })
}
